import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, HostBinding, inject } from '@angular/core';

import { DocumentUploadAreaComponent } from '@shared/components/upload/document-upload-area.component';
import { DOCUMENT_SERVICE } from '@shared/tokens/document-upload-service.token';

import { DocumentData } from './document-upload.interface';
import { DocumentUploadService } from './document-upload.service';

@Component({
  templateUrl: './document-upload-popin.component.html',
  imports: [DocumentUploadAreaComponent],
  standalone: true,
  providers: [
    {
      provide: DOCUMENT_SERVICE,
      useClass: DocumentUploadService,
    },
  ],
})
export class DocumentUploadPopinComponent {
  @HostBinding('class') public classAttribute =
    'tw-block tw-relative tw-bg-white tw-p-10 part tw-max-h-screen tw-overflow-y-auto';

  private readonly documentService = inject<DocumentUploadService>(DOCUMENT_SERVICE);

  private readonly data: DocumentData = inject(DIALOG_DATA);

  private readonly dialogRef = inject(DialogRef);

  protected close(): void {
    this.dialogRef.close();
  }
}
